module.exports = __webpack_public_path__ + "img/map-cluster.72e9d509.png";